module.exports = __webpack_public_path__ + "static/media/price.7a254bae.svg";